var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.36133 10.5C2.36133 7.55372 2.36133 6.08059 3.27662 5.16529C4.19191 4.25 5.66505 4.25 8.61133 4.25H11.7363C14.6826 4.25 16.1558 4.25 17.071 5.16529C17.9863 6.08059 17.9863 7.55372 17.9863 10.5C17.9863 13.4463 17.9863 14.9195 17.071 15.8347C16.1558 16.75 14.6826 16.75 11.7363 16.75H8.61133C5.66505 16.75 4.19191 16.75 3.27662 15.8347C2.36133 14.9195 2.36133 13.4463 2.36133 10.5Z",
    stroke: "#fff",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48633 7.375L7.17297 8.78053C8.60784 9.97625 9.32531 10.5741 10.1738 10.5741C11.0223 10.5741 11.7398 9.97625 13.1747 8.78053L14.8613 7.375",
    stroke: "#fff",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.e6964e408d1e5f77cf1a30738c81cf91.svg";
export { ForwardRef as ReactComponent };